var $ = window.jQuery;

export default $;
